import { Inject, Injectable } from '@angular/core';
import { TWA_IN_APP_REVIEW_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/twa-in-app-review/tokens';
import { TwaInAppReviewConfig, TwaInAppReviewConfigLoader } from '@bcf-v2-configurators/tokens/twa-in-app-review/types';
import { TwaNativeApiClient } from './twa-native-api-client';

@Injectable({
  providedIn: 'root'
})
export class TwaInAppReviewManager {
  private _messageAction: string = 'in-app-review-request';

  constructor(
    @Inject(TWA_IN_APP_REVIEW_CONFIG_LOADER) private _twaInAppReviewConfigLoader: TwaInAppReviewConfigLoader,
    private _twaNativeApiClient: TwaNativeApiClient
  ) {}

  public async requestReview(): Promise<void> {
    const config: TwaInAppReviewConfig = await this._twaInAppReviewConfigLoader();
    if (config.enabled) {
      this._twaNativeApiClient.sendMessage({
        action: this._messageAction,
        minTimePeriodSinceFirstAppLaunch: config.minTimePeriodSinceFirstAppLaunch,
        timestamp: config.timestamp
      });
    }
  }
}
